import React, { useEffect, useState, useRef } from "react";
import { ContextProviderComponent } from "./Context.js";
import styled from "styled-components";

import GlobalStyle from "styles/globalStyles.js";
//assets

//styles

//components
const MainWrapper = styled.div`
  position: relative;
`;

const HomePage = ({ data, children, pageContext }) => {

  return (
    <>
      <GlobalStyle />
      <ContextProviderComponent> {children}</ContextProviderComponent>
    </>
  );
};

export default HomePage;

export const Head = () => <></>;
